import React from 'react';
import { InsightSection } from 'store/state/insightsContext';
import { InsightType } from 'utils/entities';
import { useLocale } from 'locale';
import { DetailPageEventCategory } from 'analytics/handlers/detailPageSectionHandlers';
import CarouselStories from 'components/view-pager-to-stories';
import WidgetCollapsedWrapper from '../common/widget-collapsed-wrapper';
import { IInsightPreview } from '../common/styled';
import { useTheme } from 'hooks/useTheme';


interface NeighbourhoodLifeWidgetProps {
  eventCategory: DetailPageEventCategory;
  hideWidget: boolean;
  carouselData: IInsightPreview[];
  carouselIdx: number;
  setActiveCarouselIdx: (index: number) => void;
  onReadMoreCarouselClick: (id: string) => void;
  isCollapsed: boolean;
  showCarousel: boolean;
}

export const NeighbourhoodWidget: React.FC<NeighbourhoodLifeWidgetProps> = ({
  hideWidget = false,
  carouselData,
  onReadMoreCarouselClick,
  setActiveCarouselIdx,
  carouselIdx,
  isCollapsed,
  showCarousel,
}) => {
  const { t } = useLocale();
  const { colors } = useTheme();

  const widgetHasCarouselData = isCollapsed && showCarousel && carouselData && carouselData.length;

  if (hideWidget && !widgetHasCarouselData) return null;

  const carousel = (
    <CarouselStories
      insights={carouselData}
      onReadMoreClick={onReadMoreCarouselClick}
      slideIndex={carouselIdx}
      onSlideIndexChange={setActiveCarouselIdx}
      color={colors.insights.livability}
    />
  );

  const wrapperProps = {
    carousel: widgetHasCarouselData ? carousel : null,
    targetId: InsightSection.NeighbourhoodLife,
    styleType: InsightType.Livability,
    title: t('widgetTitle.neighbourhoodLife'),
  };

  return <WidgetCollapsedWrapper {...wrapperProps} />;
};

export default NeighbourhoodWidget;
